import { render, staticRenderFns } from "./AlertList.vue?vue&type=template&id=1ccb77b6&"
import script from "./AlertList.vue?vue&type=script&lang=ts&"
export * from "./AlertList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports